import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";

import Divider from "material-ui/Divider";
import Dialog, { DialogContent, DialogTitle } from "material-ui-next/Dialog";

import { enumWhitelabel } from "assets";

import {
  StyledButton,
  Loadable,
  Panel,
  TextField,
  Link,
  EntitySelector
} from "components/support";

import { brands } from "assets";

import style from "./style";

class LoginView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      recoveryEmail: ""
    };
  }

  handleChange = field => event => {
    const stateChange = {};
    stateChange[field] = event.target.value;
    this.setState(stateChange);
  };

  submitForm = e => {
    e.preventDefault();
    this.props.presenter.onLogin(this.state.email, this.state.password);
  };

  showSignup = () => {
    this.props.presenter.onSignup();
  };

  openPasswordRecovery = e => {
    e.preventDefault();
    this.props.presenter.onPasswordRecoveryOpen();
  };

  cancelPasswordRecovery = e => {
    e.preventDefault();
    this.props.presenter.onPasswordRecoveryClose();
  };

  submitPasswordRecoveryForm = e => {
    e.preventDefault();
    this.props.presenter.submitPasswordRecovery(this.state.recoveryEmail);
  };

  errorSection = () => {
    if (!this.props.viewModel.error) {
      return;
    }

    return <Panel type="error" content={this.props.viewModel.error} />;
  };

  render() {
    const { viewModel, className, presenter } = this.props;
    const { loading, passwordRecovery, enviromentSelector, enviroments, email, password } = viewModel;

    return (
      <div className={`${className} full-width`} id="login">
        <div className="layout-full-height grid-container main-div">
          <Row className="layout-full-height" middle="xs">
            <Col xs={12}>
              <div className="text-center">
                <img
                  src={brands.png.primary}
                  height="80"
                  alt="PDVend"
                  className="pdvend-logo"
                />
              </div>
              <Row center="xs">
                <Col xs={12} sm={9} md={5} lg={4}>
                  <Paper elevation={3}>
                    <Loadable loading={loading}>
                      <form onSubmit={this.submitForm}>
                        <div className="login__inner">
                          <TextField
                            fullWidth
                            label="E-mail"
                            type="email"
                            required={true}
                            disabled={loading}
                            value={this.state.email}
                            onChange={this.handleChange("email")}
                          />
                          <br />
                          <TextField
                            fullWidth
                            label="Senha"
                            type="password"
                            required={true}
                            minLength={8}
                            disabled={loading}
                            value={this.state.password}
                            onChange={this.handleChange("password")}
                            rightLabel={
                              <Link
                                onClick={this.openPasswordRecovery}
                                label={"Esqueceu sua senha?"}
                                className="password-recovery"
                              />
                            }
                          />
                        </div>

                        {this.errorSection()}

                        <div className="p-sm">
                          <StyledButton
                            primary
                            type="submit"
                            disabled={loading}
                          >
                            Entrar
                          </StyledButton>
                        </div>
                      </form>

                      <div className="divider-style">
                        <Divider />
                      </div>

                      <div className="signup-style">
                        <span>{`Novo na ${enumWhitelabel.formLabels}? `}</span>
                        <Link url={"app.signup"} label={"Faça seu cadastro!"} />
                      </div>
                    </Loadable>
                  </Paper>
                </Col>
              </Row>
            </Col>
          </Row>

          <EntitySelector
            hideField={true}
            title="Selecione o ambiente"
            open={enviromentSelector}
            fixedOptions={enviroments}
            onSelect={env => presenter.onSelectEnviroment(env, email, password)}
            parser={env => ({
              key: env.id,
              title: env.name,
            })}
            onClose={() => {}}
            allowClose={false}
          />

          <Dialog open={passwordRecovery.open} className="text-center">
            <Loadable loading={passwordRecovery.loading}>
              <DialogTitle>
                <span>Redefina sua Senha</span>
              </DialogTitle>
              <DialogContent className={className}>
                <Row className="layout-full-height" middle="xs">
                  <Col xs>
                    <span>
                      Informe seu email no campo abaixo e enviaremos um link
                      para redefinir sua senha.
                    </span>
                    <br />
                    <form onSubmit={this.submitPasswordRecoveryForm}>
                      <div className="login__inner full-width">
                        <TextField
                          fullWidth
                          label="E-mail"
                          type="email"
                          required={true}
                          disabled={loading}
                          value={this.state.recoveryEmail}
                          onChange={this.handleChange("recoveryEmail")}
                        />
                        <br />
                      </div>
                      <div className="password-recovery-dialog">
                        <StyledButton
                          flat
                          label="Cancelar"
                          type="button"
                          onClick={this.cancelPasswordRecovery}
                        />
                        <StyledButton primary label="Recuperar" type="submit" />
                      </div>
                    </form>
                  </Col>
                </Row>
              </DialogContent>
            </Loadable>
          </Dialog>
        </div>
      </div>
    );
  }
}

export default style(LoginView);



// WEBPACK FOOTER //
// ./src/components/app/login/view.jsx